export const educationData = [
    {
        id: 1,
        institution: 'College of Engineering Muttathara',
        course: 'B Tech Mechanical Engineering',
        startYear: '2017',
        endYear: '2021'
    },
   
    {
        id: 2,
        institution: 'Masai School of Coding',
        course: 'Full-Stack Web Development',
        startYear: '2021',
        endYear: 'Present'
    },
]